// Configuration panel — the detail pane overlaying the table from the left, so it
// emerges from the ⚙ button that opened it.
//
// It covers the left gutter and the Workflow column; the panel header carries the title
// and short code, so which workflow is being edited is never in doubt.
//
// Focus is trapped (Chakra's default). An earlier version set trapFocus={false} to "keep
// the nav reachable", which was wrong twice over: the overlay already covers the nav, and
// without focus inside the dialog Chakra's Escape handler never fires, so the panel could
// not be dismissed with Escape. Caught by workflows_listing.spec.ts.

import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
} from '@chakra-ui/react';
import { Chatbot } from '@/lib/sdk/chatbot/types';
import { WorkflowDetailPane } from './WorkflowDetailPane';

interface WorkflowConfigPanelProps {
  chatbot: Chatbot | null;
  onClose: () => void;
  onDeleted: () => void;
}

export function WorkflowConfigPanel({ chatbot, onClose, onDeleted }: WorkflowConfigPanelProps) {
  return (
    <Drawer
      isOpen={chatbot !== null}
      onClose={onClose}
      placement="left"
      size="lg"
    >
      <DrawerOverlay />
      <DrawerContent bg="bg-surface" data-testid="wfl-config-panel">
        <DrawerCloseButton zIndex={2} />
        <DrawerBody p={0}>
          {chatbot && (
            <WorkflowDetailPane
              key={chatbot.id}
              chatbot={chatbot}
              onDeleted={() => {
                onDeleted();
                onClose();
              }}
            />
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
